<template>
  <div>
    <div v-if="showloading">

      <loader-appie/>

    </div>

<!--    <sidebar-home-one :sidebar="sidebar" :side="SideMenu" @toggleSidebar="toggleSidebar" :menuItems="navs"/>-->
<!--    &lt;!&ndash;====== OFFCANVAS MENU PART ENDS ======&ndash;&gt;-->

<!--    &lt;!&ndash;====== APPIE HEADER PART START ======&ndash;&gt;-->

<!--    <header-home-two @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"-->
<!--                     :menuItems="navs"/>-->


    <section class="appie-testimonial-2-area  " id="testimonial">
      <div class="container "  v-if="!showloading" >
        <BackButton />
        <div class="row">
          <div class="col-md-3 whitebackground menudiv" >
            <menubar @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"
                     :menuItems="navs"/>
          </div>
          <div class="col-md-9 graybackground contentdiv">
            <div class="row mt-2">
              <div class="col-lg-12 ">
                <div>

                  <Commonprofile/>
                </div>
                <!--            {{title}}-->
<!--                <center>-->
                  <span v-html="title" class="text-center mt-2"></span>
<!--                </center>-->
                <br>
                <div class="" style="cursor: pointer">
                  <div v-for="(templateData,index) in template" :key="index">
<!--                    <div v-if="templateData.template_8 && templateData.template_8.length > 0">-->
<!--                      <div v-for="(item, itemIndex) in templateData.template_8" :key="itemIndex" style="text-align: center">-->

<!--                        <a @click="GetPlanimage(item.activity,item.url)">-->
<!--                          <img :src="item.src" alt="" style="min-width: -webkit-fill-available;">-->
<!--                        </a>-->

<!--                      </div>-->
<!--                    </div>-->
                    <div v-if="templateData.template_9 && templateData.template_9.length > 0">
                      <div v-for="(item, itemIndex) in templateData.template_9" :key="itemIndex">
                        <section class="whitebackground " id="features">
                          <div class="row  align-items-center">
                            <div class="col-lg-12">
                              <div class=" ">
                                <a @click="postJob(item.activity,item.url)" style="display: block;">
                                  <div class="appie-features-box-item item-2  appie-features-box-5-item"
                                       :style="{borderColor:item.borderColor}">
                                    <img :src="item.image" alt="" class="imageSize">

                                    <span :style="{ color: item.txt_color,marginLeft:'20px' }">{{ item.title }}</span>
                                    <span class="badge"
                                          :style="{ color: item.btntextColor,float:'right',border:item.borderColor,backgroundColor:item.btnColor }"
                                          v-html="item.btnText"></span>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>

                    <div v-if="templateData.template_12 && templateData.template_12.length > 0">
                      <section class=" pt-20 pb-10" id="">


                        <div class="col-12 col-md-12">
                          <div class="row">
                            <div class="col-12 col-md-4 col-lg-4 mb-20 temp_10_space"
                                 v-for="(item, itemIndex) in templateData.template_12" :key="itemIndex">
                              <a @click="ChangeRoute(item.activity,item.url)" style="display: block;">
                                <div class="card" >
                                  <div class="card-body">
                                    <!--                            <button class="temp_10" :style="{ background : item.btnColor}">-->
                                    <!--                              <img :src="item.icon" alt="" style="min-width: 50%">-->
                                    <!--                            </button>-->
                                    <!--                            <h5 class="card-title text_space" :style="{ color:item.txt_color, textAlign:'center' }" >{{item.title}}</h5>-->
                                    <h5 v-html="item.count"></h5>
                                    <h5 v-html="item.title !='' ? item.title : ''"></h5>
                                    <div class="row">
                                      <!--                              <div class="col-6 col-sm-3">-->
                                      <div class="col-12">
                                        <img :src="item.icon" alt="" style="width: 20%;float: right;">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </a>
                            </div>

                          </div>
                        </div>


                      </section>
                    </div>

                    <br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>


      <div>
        <b-modal id="modal-center1" centered title="BootstrapVue">
          <div class="row">
            <!-- First Card Row -->
            <div class="col-12 col-lg-12 col-md-12 mb-4" v-for="(customerCareData,index) in customerCare" :key="index">
              <span v-html="customerCareData.label"></span>


              <div class="card" >
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-2 col-lg-2 col-md-2">
                      <div class="d-flex justify-content-center align-items-center h-100">
                        <i class="fa fa-phone flipped" style="background: white;" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="col-8 col-lg-8 col-md-8">
                      <div class="d-flex flex-column justify-content-center h-100">
                        <span>{{ customerCareData.name }}</span>
                        <span v-html="customerCareData.description"></span>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </section>


    <!--====== APPIE TESTIMONIAL 2 PART ENDS ======-->

    <!--====== APPIE SPONSER PART START ======-->

    <!--    <sponser-home-two title="Appie works best with" more_title="your favorite platforms" description="Join over 40,000 businesses worldwide."/>-->

    <!--====== APPIE SPONSER PART ENDS ======-->

    <!--====== APPIE FOOTER PART START ======-->

    <!--    <footer-home-two/>-->


    <!--====== APPIE FOOTER PART ENDS ======-->


    <!--====== APPIE BACK TO TOP PART ENDS ======-->
    <div class="back-to-top back-to-top-2">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import LoaderAppie from '../LoaderAppie.vue'
import video_bg_thumb from "@/assets/images/video-thumb-1.jpg"
import hero_img from '@/assets/images/hero-thumb-3.png'
// import SidebarHomeOne from '../HomeOne/SidebarHomeOne.vue'

// import HeaderHomeTwo from '../HomePage/Header.vue'
import Menubar from '../HomePage/menu.vue'
import BackButton from '../HomePage/BackButton.vue';

import {callAxiosWithConfig} from "@/main";
import {right} from "core-js/internals/array-reduce";
import CryptoJS from "crypto-js";
import Commonprofile from "@/components/HomePage/commonprofilediv.vue";


export default {
  props: {
    section_heading: {
      type: String,
    },
    more_heading: {
      type: String
    },
    description: {
      type: String
    },
    grid_items: {
      type: Array,
    }
  },
  components: {
    Commonprofile,
    BackButton,
    // HeaderHomeTwo,
    LoaderAppie,

    // SidebarHomeOne,
    Menubar,
  },
  data() {
    return {
      showloading:false,
      SideMenu: {},
      titleWord: '',
      customerCare: {},
      template: '',
      urlData: '',
      ViewPosttitle: '',
      sidebar: false,
      navs: [
        {
          // name:'contact',
          name: 'Home',
          path: '/home-page'
        },
        {
          name: 'Profile',
          childrens: [
            {
              // name:'Home 1',
              name: 'Update KYC',
              path: '/'
            },
            {
              // name:'Home 2',
              name: 'Update Profile',
              path: '/home-two'
            },
            {
              // name:'Home 3',
              name: 'View Profile',
              path: '/home-three'
            },
            {
              // name:'Home 4',
              name: 'Viewed Profiles',
              path: '/home-four'
            },
            // {
            //   // name:'Home 5',
            //   name: 'Change Mobile Number',
            //   path: '/home-five'
            // },

          ],
        },

        {
          // name:'contact',
          name: 'Customer Care',
          path: '/contact'
        },

      ],
      hero_img: hero_img,
      video_bg_thumb: video_bg_thumb
    }
  },
  mounted() {
    document.addEventListener('scroll', this.topToBottom)
  },


  async created() {
    // console.log('view created page')
    if (this.$route.query.page) {
      // console.log('page',this.$route.query.page)
      this.showloading=true;
      const pageurl = this.$route.query.page;
      const decryptedString = this.decryptUrl(pageurl);
      this.modifiedString = decryptedString;
      try {
        const ViewPostData = await callAxiosWithConfig(this.modifiedString, '', 'post');
        // console.log(ViewPostData)
        this.showloading=false;
        this.title = ViewPostData.title;
        // console.log(this.title)
        this.template = ViewPostData.template;

        this.SideMenu = JSON.parse(localStorage.getItem("SideMenu"));
        this.titleWord = JSON.parse(localStorage.getItem("titleWord"));
        this.customerCare = JSON.parse(localStorage.getItem("customerCare"));

        // console.log(this.SideMenu)
        this.$emit("tempData", this.SideMenu);
        this.$emit("title", this.titleWord);
        this.$emit("customerCare", this.customerCare);

      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Handle 401 status silently
          // For example, do nothing or log a message without displaying it
        } else {
          // Handle other errors by displaying them
          if (error.response && error.response.status === 401) {
            // Handle 401 status silently
            // For example, do nothing or log a message without displaying it
          } else {
            // Handle other errors by displaying them
            console.error('Error in Axios request:', error);
          }
        }

      }
    }
    else{
      console.log('out',)
    }


  },

  methods: {
    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },
    Decrypt(str) {
      return str.replace(/[a-zA-Z]/g, function (char) {
        const charCode = char.charCodeAt(0);
        const decryptedCharCode = charCode - 1; // Decryption logic
        return String.fromCharCode(decryptedCharCode);
      });
    },

    right,
    topToBottom() {
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        result.style.display = "block";

      } else {
        result.style.display = "none";

      }
    },


    toggleSidebar() {
      this.sidebar = !this.sidebar
    },

    Encrypt(str) {
      // return str.split('').map(char => char.charCodeAt(0)).join('-');
      return str.replace(/[a-zA-Z]/g, function (char) {
        // Replace each alphabetic character with its encrypted value
        const charCode = char.charCodeAt(0);
        const encryptedCharCode = charCode + 1; // You can use a different encryption logic
        return String.fromCharCode(encryptedCharCode);
      });
    },
    async GetPlanimage(activity, url) {
      // alert(activity);
      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      this.urlData = url;
      if (lastPart === 'Employer_Common_Webview_Activity') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/plan-purchase?page=${encodeURIComponent(encryptedString)}`)

      }

    },


    async ChangeRoute(activity, url) {
      // const encryptedString = this.encryptUrl(url);
// alert(activity)
// alert(url)
      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      // alert(lastPart);
      this.urlData = url;


      if (lastPart === 'Employer_Common_Webview_Activity') {

        // window.location.href = this.urlData
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/plan-purchase?page=${encodeURIComponent(encryptedString)}`)

      } else if (lastPart == 'Employer_Company_Register') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
      } else if (lastPart === 'Employer_Dynamic_Job_List') {
        const desiredPath = url.split('/').pop();
        // alert(desiredPath);
        if (desiredPath == 'paymentHistory') {
          // alert('s')
          const encryptedString = this.encryptUrl(url);
          await this.$router.push(`/payment-history?page=${encodeURIComponent(encryptedString)}`);
        } else {
          // alert('mo')
          const encryptedString = this.encryptUrl(url);
          await this.$router.push(`/waiting-post?page=${encodeURIComponent(encryptedString)}`);
        }


      }
    },

    async postJob(activity, url) {
      // alert(activity)
      // alert(url)
      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      // alert(lastPart);
      this.urlData = url;
      if (lastPart === 'Employer_Dynamic_Home_Activity') {
        try {
          const ViewPostData = await callAxiosWithConfig(this.urlData, '', 'post');
          // console.log(otpdatViewPostData);
          // console.log(ViewPostData);
          this.ViewPosttitle = ViewPostData.title;
          // this.template = otpdata.template;
          // console.log(this.template)
          // const inputString = otpdata;
        } catch (error) {
          console.error('Error in Axios request:', error);
        }
      } else if (lastPart === 'Employer_Common_Webview_Activity') {

        // window.location.href = this.urlData
        // const encryptedString = this.encryptUrl(url);
        // await this.$router.push(`/plan-purchase?page=${encodeURIComponent(encryptedString)}`)
        window.open(this.urlData, '_blank');
      } else if (lastPart === 'Employer_Company_Register') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
      }

    }

  }

}
</script>

<style>
.appie-features-box-item {
  padding: 10px 12px 12px 10px;
}

.appie-features-box-item.item-2:hover {
  border-color: unset;
}

.maincard {
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
  padding: 20px 10px 10px 10px;

  width: 100% !important;
}

@media (min-width: 768px) {
  .maincard {
    width: 90% !important;
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .temp_10 {
    min-height: 100px;
    border: unset;
    width: 100%;
    border-radius: 10px;
  }

  .temp_10_space {
    margin-bottom: 30px;
  }

  .imageSize {
    width: 10%;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media (min-width: 600px) and (max-width: 767px) {

}

@media (min-width: 768px) and (max-width: 991px) {

}

/* Medium devices (landscape tablets, 768px and up) */

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .temp_10 {
    border: unset;
    width: 100%;
    min-height: 200px;
    border-radius: 10px;

  }

  .text_space {
    margin-top: 10px;
  }

  .imageSize {
    width: 4%;
  }
}
.container{
  max-width: 100%!important;
}


</style>
